module.exports = __webpack_public_path__ + "static/HumstSlab712BTWXX-Roman-3a55c906c24894c1dfe6639198f164a5.woff2";